/* BMX video unlock (2026-10-16): muted product loops that a browser refused to autoplay
   (battery saver, data saver, reduce motion, DuckDuckGo, Samsung Internet) start on first touch,
   scroll or key, are retried while on screen, and fall back to a still when they never start. */
(() => {
  if (window.__bmxVideoUnlock) return;
  window.__bmxVideoUnlock = true;
  const wants = (v) => v.muted && !v.controls && !v.ended && (v.loop || v.hasAttribute('autoplay') || v.hasAttribute('data-bmx-lazy-video') || v.hasAttribute('data-ultra-video') || v.classList.contains('bmx-media-loop')) && (v.currentSrc || v.getAttribute('src') || v.querySelector('source'));
  const onScreen = (v) => {
    const r = v.getBoundingClientRect();
    if (!(r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight)) return false;
    const s = getComputedStyle(v);
    return s.display !== 'none' && s.visibility !== 'hidden';
  };
  const play = (v) => { try { const p = v.play(); if (p && p.catch) p.catch(() => {}); } catch (e) {} };
  const sweep = () => document.querySelectorAll('video').forEach((v) => { if (v.paused && wants(v) && onScreen(v)) play(v); });
  const stillFor = (v) => {
    const url = v.dataset.fallback;
    if (!url || v.dataset.bmxFallback === 'true') return;
    v.dataset.bmxFallback = 'true';
    const img = document.createElement('img');
    img.src = url; img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.decoding = 'async';
    img.className = 'bmx-pdp-feature__video-fallback';
    v.style.display = 'none';
    v.insertAdjacentElement('afterend', img);
  };
  let tries = 0;
  const watchdog = () => {
    sweep();
    document.querySelectorAll('video[data-fallback]').forEach((v) => { if (v.paused && wants(v) && onScreen(v) && tries >= 4) stillFor(v); });
    if (++tries < 10) setTimeout(watchdog, 1200);
  };
  let last = 0;
  const unlock = () => { const n = Date.now(); if (n - last < 300) return; last = n; sweep(); };
  ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'].forEach((t) => addEventListener(t, unlock, { capture: true, passive: true }));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') sweep(); });
  addEventListener('pageshow', sweep);
  let timer; addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(sweep, 250); }, { passive: true });
  setTimeout(watchdog, 1500);
})();
